export enum HazardousMaterials {
    NA = 'NA',
    No = 'No',
    NotPresent = 'NotPresent',
    Present = 'Present',
    Trc = 'Trc',
}
